import { Fragment, useEffect, useRef, useMemo, useState } from 'react'
import { useTranslation } from "react-i18next";
import download from 'downloadjs';

import Backdrop from '../Backdrop/Backdrop';
import Loader from '../Loader/Loader';
import Modal from '../Modal/Modal.jsx';
import UploadedFileUseContent from '../UploadedFileUseContent/UploadedFileUseContent.jsx';
import VideoToAudioFileUpload from './FileUpload/VideoToAudioFileUpload';
import VideoToAudioAbout from './VideoToAudioAbout.jsx';

import VideoToAudio from './VideoToAudio.jsx';
import VideoToMp4 from './VideoToMp4.jsx';
// import VideoToAudioSocket from "./VideoToAudioSocket";

// import { convert } from 'video-to-audio';

import { useStore } from '../../hook-store/store';
import { convert } from '../../utils/video-to-audio-utils/video-to-audio-utils';
import { marks } from '../../utils/marks';

import './VideoToAudio.css';



import axios from 'axios';
import { TEXTAUDIOTOOLSNODE_URL } from '../../App.js';


function VideoToAudioAppSelect() {

  const [t] = useTranslation("translation");

  // const hiddenFileSelect = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    paramFileData,
    paramFileDataList,
   } = store.uiStore;
  // const { mlSpeechText } = store.mlSpeechStore;

  // console.log('store-answer-finder', store)
  

  const [selectedApp, setSelectedApp] = useState('video-to-audio');
  const [videoToAudioConfig, setVideoToAudioConfig] = useState();

  useEffect(() => {
    window.scrollTo(0,0);
  },[]);

  useEffect(() => {
    if (paramFileDataList && paramFileDataList.files?.length > 0) {
      
      if (paramFileDataList.openApp === 'videoToMp4') {
        setSelectedApp('video-to-mp4')
      }
    }
  },[paramFileDataList]);

  useEffect(() => {
    if (!videoToAudioConfig) {
      getVideoToAudioConfigHandler(
        TEXTAUDIOTOOLSNODE_URL,
        localStorage.getItem('token'),
      );
    }
  },[selectedApp]);


  const setSelectedAppHandler = (event) => {
    setSelectedApp(event.target.value);
  } 


  const getVideoToAudioConfigHandler = async (url, token) => {
    try {
      const response = await fetch(url + `/video-to-audio/video-to-audio-config`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error("error occured");
      }

      const resData = await response.json();
      console.log(response, resData);

      if (resData && resData.data && resData.data.videoToAudioConfig) {
        setVideoToAudioConfig(resData.data.videoToAudioConfig);
      }

    } catch(err) {
      console.log(err);
    }
  };



  let bannerElement;

  if (window.innerWidth <= 450) {
    bannerElement = (
      <iframe id="kura-text-audio-tools.spaceeight.net-1725583665876"
          style={{width:"310px", height:"70px", border:"none"}}  
          src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583665876"
      />
    );
  }

  if (window.innerWidth > 450 && window.innerWidth <= 768) {
    bannerElement = (
      <iframe id="kura-text-audio-tools.spaceeight.net-1725583679744"
      style={{width:"460px", height:"95px", border:"none"}}  
      src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583679744"
      />
    )
  }

  if (window.innerWidth > 768) {
    bannerElement = (
      <iframe id="kura-text-audio-tools.spaceeight.net-1725583699146"
          style={{width:"610px", height:"135px", border:"none"}}  
          src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583699146"
      />
    );
  }

  return (
    <Fragment>
      <div className='videoToAudio'>
        <div 
          style={{
              display: 'flex',
              justifyContent: "center",
              paddingTop: "1rem",
              paddingBottom: "2rem"
          }}
          >
            {bannerElement}
        </div>
      
      <div>
        <div>{t('videoToAudio05', 'Select app')}</div>
        <select className='selectBase'
            // name="pets" 
            // id="pet-select"
            defaultValue={'video-to-audio'}
            value={selectedApp}
            onChange={(event) => { 
              setSelectedAppHandler(event);                  
            }}
          >
            <option value={'video-to-audio'}>
              Video to Audio
            </option>
            <option value={'video-to-mp4'}>
              Convert to MP4
            </option>
          </select>
        </div>

        {selectedApp === 'video-to-audio' && (
          <VideoToAudio />
        )}
        {selectedApp === 'video-to-mp4' && (
          <VideoToMp4 
            videoToAudioConfig={videoToAudioConfig}
          />
        )}

        {/* <VideoToAudioSocket /> */}
      </div>
    </Fragment>
  )
}

export default VideoToAudioAppSelect;